import {Component, OnInit} from '@angular/core';
import {LoginService} from './services/login.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'DXCompliance';

  constructor(
    private loginService: LoginService
  ) {}

  ngOnInit(): void {
    if (!sessionStorage.getItem('logined') && localStorage.getItem('token')) {
      this.loginService.logout();
    }
  }
}
